import type { FaireProductEntity } from "../../entity_types/product";

export const p_vkzm63hkrv: FaireProductEntity = {
  token: "p_vkzm63hkrv",
  type: "product",
  name: "Tinsel Tree holiday greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/7fa4a6980792a907991fa55199468f37428abeabecc869484a4330ba2007f53e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d9cc24b706deb4634818ea1b9091a47582d2608913045a8e8fd81b407a0b9529.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "• Illustrated by Becca Stadtlander\n• A2 - 4.25 x 5.5 inch\n• Heavyweight Uncoated Cardstock\n• Printed in Full Color\n• Foil Stamped\n• Blank Interior\n• Matching Envelope\n• Sold as Single Card or Boxed Set of 8\n• Printed in the USA",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:18.289Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
